const accessTerm = {
  display: {
    go_to_home: 'Ir al Inicio',
    password_info:
      'Esta contraseña de acceso tiene una duración de un año a partir de la fecha de esta validación.',
    print_access_term: 'Imprimir Término de Acceso',
    more_info: 'Conoce más',
    company_name: 'Clicksign Gestão de Documentos S.A.',
    document_access_term: 'Término de Acceso a Documento Electrónico',
    validation: 'Validación',
    original_eletronic_info:
      'Este término proporciona información para ingresar al documento electrónico original adjunto:',
    how_to_access: 'Cómo ingresar y validar el documento electrónico',
    instruction:
      'Sigue las instrucciones a continuación para ingresar al contenido completo del documento firmado electrónicamente, así como para validar a los firmantes y sus respectivos puntos de autenticación.',
    how_to_access_document: 'Para ingresar al documento a través de contraseña:',
    how_to_access_via_qrcode: 'Para ingresar al documento a través de Código QR',
    password: 'Contraseña de acceso',
    qrcode_access: 'Código QR de acceso',
    qrcode_description:
      'Usa un lector de Código QR para ser dirigido a la página de validación de este documento en Clicksign.',
    access_validator: 'Ingresa a:',
    password_validator: 'Haz click en el botón “Validar con contraseña”.',
    type_password: 'Ingresa la contraseña a continuación y haz click en “Validar”.',
    validator_site: 'https://www.clicksign.com/validador.',
    file_hash: 'Hash del archivo validado (SHA256):',
    validate_another_document: 'Validar otro documento',
    print: 'Imprimir',
  },
  generate_password: {
    title: 'Validar documento a través de Contraseña',
    subtitle: 'Tengo la contraseña de acceso al documento que quiero validar en Clicksign.',
    validate: 'Validar',
  },
  result: {
    seeTheDocument: 'Ver el documento.',
    seeDocument: 'Ver documento y validar firmas',
    downloadDocument: 'Descargar documento',
  },
};

export default accessTerm;
